<template>
	<button name="button" type="button" class="btn btn-light w-100">
		<span class="default">
			<ShareSvg/>
			<span v-if="!errorCode">{{ sharePositionMessage }}</span>

			<template v-else-if="errorCode === 1">
				<p v-if="this.onIosDevice()" v-html="$t('share_position.geolocation_refused.no_mobile_device')"></p>
				<p v-else-if="this.onAndroidDevice()" v-html="$t('share_position.geolocation_refused.android_device')"></p>
				<p v-else v-html="$t('share_position.geolocation_refused.no_mobile_device')"></p>
			</template>

			<p v-else-if="errorCode === 2"  v-html="$t('share_position.geolocation_not_available')"></p>
			<p v-else-if="errorCode === 3" v-html="$t('share_position.geolocation_too_long')"></p>
		</span>
	</button>
</template>

<script>
  import ShareSvg from '@images/ShareSvg.vue'

  export default {
    props: {
	  sharePositionMessage: String,
	  errorCode: Number
	},
	components: {
	  ShareSvg
	},
	methods: {
	  onIosDevice() {
		return /iPad|iPhone|iPod/.test(navigator.userAgent)
		},
		onAndroidDevice() {
		  return /android/i.test(navigator.userAgent)
		}
	}
  }
</script>
